import { axios } from '../account'

const LOG_URL = '/log'

/**
 * Create a log entry.
 */
async function logAPI(level, str) {
  try {
    await axios.post(LOG_URL, {
      log: {
        level,
        message: `[frontend] ${str}`
      }
    })
  } catch (error) {}
}

var Log = {
  async info(str) {
    console.info(str);
    await logAPI('info', str)
  },
  async debug(str) {
    console.debug(str);
    await logAPI('debug', str)
  },
  async warn(str) {
    console.warn(str);
    await logAPI('warn', str)
  },
  async fatal(str) {
    console.fatal(str);
    await logAPI('fatal', str)
  },
  async error(str) {
    console.error(str);
    await logAPI('error', str)
  },
  userPrefix(userId) {
    return userId ? `User (${userId})` : 'A guest'
  }
}

export default Log
